module.exports = __webpack_public_path__ + "img/trans-DP.c3a2f001.svg";